
export const mutations = {
  setCreateResponse(state, response) {
    state.createResponse = response;
  },

  setCreateBulkResponse(state, response) {
    state.createBulkResponse = response;
  },
};
